import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { IntranetSeguridadService } from '../../../../core/services/intranet-seguridad.service';
import { AlertaService } from '../../../../core/services/alerta.service';

interface AppError {
  IdAppError: number;
  Categoria: string;
  Ruta?: string;
  Mensaje: string;
  StackTrace?: string;
  VersionApp?: string;
  Dispositivo?: string;
  SistemaOperativo?: string;
  Datos?: unknown;
  Fotos?: unknown;
  Usuario?: string;
  Revisado: number;
  FechaCreacion: string;
}

@Component({
  selector: 'app-reporte-monitoreo',
  templateUrl: './monitoreo.component.html',
  styleUrl: './monitoreo.component.scss',
  imports: [CommonModule, DatePipe, ButtonModule, DialogModule, TableModule],
})
export class ReporteMonitoreoComponent implements OnInit, OnDestroy {
  errores: AppError[] = [];
  cargando = false;
  detalle: AppError | null = null;
  visibleDetalle = false;
  imagenSeleccionada = '';
  visibleImagen = false;
  private refresco?: ReturnType<typeof setInterval>;

  constructor(
    private readonly seguridad: IntranetSeguridadService,
    private readonly alerta: AlertaService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.cargar();
    this.refresco = setInterval(() => this.cargar(), 60000);
  }

  ngOnDestroy(): void { if (this.refresco) clearInterval(this.refresco); }

  cargar(): void {
    this.cargando = true;
    this.seguridad.post<AppError[]>('reportes/monitoreo/listar').pipe(
      finalize(() => {
        this.cargando = false;
        this.cdr.detectChanges();
      }),
    ).subscribe({
      next: (respuesta) => {
        this.errores = respuesta.isSuccess ? respuesta.value ?? [] : [];
        if (!respuesta.isSuccess) this.alerta.openAlerta('Monitoreo', respuesta.message || 'No se pudieron cargar los errores.', 'error');
      },
      error: () => this.alerta.openAlerta('Monitoreo', 'No se pudieron cargar los errores.', 'error'),
    });
  }

  revisar(error: AppError): void {
    this.seguridad.post('reportes/monitoreo/revisar', { idAppError: error.IdAppError }).subscribe({
      next: (respuesta) => { if (respuesta.isSuccess) this.cargar(); else this.alerta.openAlerta('Monitoreo', respuesta.message, 'error'); },
      error: () => this.alerta.openAlerta('Monitoreo', 'No se pudo actualizar el error.', 'error'),
    });
  }

  verDetalle(error: AppError): void {
    this.detalle = error;
    this.visibleDetalle = true;
  }

  ampliarImagen(url: string): void {
    this.imagenSeleccionada = url;
    this.visibleImagen = true;
  }

  fotosDetalle(): string[] {
    const datos = this.detalle?.Fotos ?? this.detalle?.Datos;
    if (!datos) return [];
    try {
      const valor = typeof datos === 'string' ? JSON.parse(datos) : datos;
      if (Array.isArray(valor)) return valor.filter((foto): foto is string => typeof foto === 'string');
      return Array.isArray((valor as { fotos?: unknown }).fotos)
        ? (valor as { fotos: unknown[] }).fotos.filter((foto): foto is string => typeof foto === 'string')
        : [];
    } catch { return []; }
  }
}
